import {
  IonContent,
  useIonModal,
  useIonToast,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonButton,
  IonSegment,
  IonSegmentButton,
  IonFooter,
  isPlatform,
} from "@ionic/react";
import { OverlayEventDetail } from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import { useEffect, useState } from "react";
import Spinner from "../../components/atoms/spinner";
import MyAdvertisements from "../myAdvertisements";
import userSvg from "../../images/blue-user.svg";
import phoneOfficeSvg from "../../assets/uicons/svg/fi-ts-phone-office.svg";
import phoneSvg from "../../assets/uicons/svg/fi-ts-circle-phone-flip.svg";
import emptySvg from "../../images/empty.svg";
import landLocationSvg from "../../assets/uicons/svg/fi-ts-land-location.svg";
import realEstateEmpoloyeeSvg from "../../assets/uicons/svg/fi-ts-employee-man.svg";
import realEstateEmpoloyeesSvg from "../../assets/uicons/svg/fi-ts-employees.svg";
import { Clipboard } from "@capacitor/clipboard";
import { presentToastFunction } from "../../services/genericMethoud/generice";
import {
  call,
  chevronBackOutline,
  heart,
  logoWhatsapp,
  mailOutline,
  megaphoneOutline,
  personOutline,
  shareOutline,
} from "ionicons/icons";
import {
  GetMaxAddCountByRegionFunction,
  GetUserFunction,
} from "../../services/API";
import { useSelector } from "react-redux";
import Joyride from "react-joyride";
import LightGalleryComponent from "../../components/molecules/LightGalleryComponent";
import "./style.css";
import CreateFavoriteLand from "../createFavoriteLand";

const EstateBrokersModal = ({
  currentRegion,
  id,
  onCloseEstateBrokersDismiss,
}: {
  currentRegion: any;
  id?: any;
  onCloseEstateBrokersDismiss: (
    currentRegion?: string | null | undefined | number,
    role?: string
  ) => void;
}) => {
  const [estateBroker, setEstateBroker]: any = useState();
  const [otherBrokers, setOtherBrokers]: any = useState();
  const [topBroker, setTopBroker]: any = useState();

  let { token } = useSelector((state: any) => state.reducer);

  const [isLoading, setIsLoading] = useState(false);

  const [currentEstateBroker, setCurrentEstateBroker] = useState(
    "realEstateEmpoloyee"
  );
  let [presentToast] = useIonToast();

  function getTopBroker(regionName: any) {
    setTopBroker(null);
    GetMaxAddCountByRegionFunction(regionName, false).then((result: any) => {
      if (result.status == 200) {
        console.log("NEW NEW NEW==>", result);
        setTopBroker(result.data);
      }
    }).finally(() => {
      setIsLoading(false);
    });
  }

  function getEstateBrokerById(id: any) {
    setEstateBroker(null);
    GetUserFunction(id, token).then((result: any) => {
      if (result.status == 200) {
        console.log("aaaaaaaaaaaaaa==>", result);
        setEstateBroker(result?.data?.dateSet);
      }
    }).finally(() => {
      setIsLoading(false);
    });
  }

  function getOtherBrokers(regionName: any) {
    setIsLoading(true);
    setOtherBrokers(null);
    GetMaxAddCountByRegionFunction(regionName, true).then((result: any) => {
      if (result.status == 200) {
        console.log("NEW NEW OTHERS==>", result);
        setOtherBrokers(result.data);
      }
    }).finally(() => {
      setIsLoading(false);
    });
  }

  useEffect(() => {
    setIsLoading(true);
    if (id) {
      setIsLoading(true);
      getEstateBrokerById(id);
      setCurrentEstateBroker("realEstateEmpoloyeeById");
    } else {
      setIsLoading(true);
      getTopBroker(currentRegion);
      setCurrentEstateBroker("realEstateEmpoloyee");
    }
  }, [currentRegion]);

  const [presentMyAdvertisements, disMissmyAdvertisements] = useIonModal(
    MyAdvertisements,
    {
      onDismissMyAdvertisements: (data: string, role: string) =>
        disMissmyAdvertisements(data, role),
      userId:
        estateBroker?.userId ??
        estateBroker?.id ??
        topBroker?.userId ??
        topBroker?.id ??
        id,
    }
  );

  function openMyAdvertisementsModal() {
    console.log("topBrokertopBrokertopBroker", topBroker);
    console.log("estateBrokerestateBrokerestateBroker", estateBroker);
    console.log("otherBrokersotherBrokersotherBrokers", otherBrokers);

    if (
      estateBroker?.userId ||
      estateBroker?.id ||
      topBroker?.userId ||
      topBroker?.id ||
      id
    ) {
      presentMyAdvertisements({
        onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
          if (ev.detail.role === "confirm") {
          }
        },
      });
    }
  }

  const [CreateFavoriteLandPresent, CreateFavoriteLandDismiss] = useIonModal(
    CreateFavoriteLand,
    {
      CreateFavoriteLandDismiss: (data: string, role: string) =>
        CreateFavoriteLandDismiss(data, role),
      id:
        estateBroker?.userId ??
        estateBroker?.id ??
        topBroker?.userId ??
        topBroker?.id ??
        id,
    }
  );

  function openCreateFavoriteLandModal() {
    if (
      estateBroker?.userId ||
      estateBroker?.id ||
      topBroker?.userId ||
      topBroker?.id ||
      id
    ) {
      CreateFavoriteLandPresent({
        animated: true,
        onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
          if (ev.detail.role === "confirm") {
          }
        },
      });
    }
  }

  const [run, setRun]: any = useState(true);
  const [steps] = useState([
    {
      target: ".EstateBrokerToClipboard",
      content:
        "نسخ عنوان الوسيط العقاري: بالضغط عليه يتم نسخ عنوان الوسيط العقاري للوصول اليه مره اخري بشكل اسرع.",
      placement: "right" as const,
      disableBeacon: true,
    },
    {
      target: ".profilePhoto",
      content:
        "الصوره الشخصيه للوسيط: يتم عرض الصوره الشخصيه للوسيط العقاري ان وجدت.",
    },
    {
      target: ".adsNum",
      content:
        "البيانات المختصره: يتم عرض اسم الوسيط العقاري وعدد الإعلانات الي قام بها الوسيط العقاري في المنطقة بشكل سريع اسفل صورته.",
    },
    {
      target: ".moreDetails",
      content:
        "بيانات اضافية: هنا يتم عرض بيانات اضافية للوسيط العقاري ان وجت.",
    },
    {
      target: ".getEstateAllAds",
      content:
        "مشاهدة الاعلانات: عند الضغط يتم عرض جميع اعلانات الوسيط العقاري والذهاب اليها.",
      placement: "top" as const,
    },
    {
      target: ".getEstateFavourites",
      content:
        "مشاهدة المفضلة: عند الضغط يتم عرض جميع المفضلات للوسيط العقاري والذهاب اليها.",
      placement: "top" as const,
    },
    // {
    //   target: ".topEstateBroker",
    //   content:
    //     "الوسيط العقاري الأكثر رواجًا: يتم عرض الوسيط العقاري الأكثر رواجاً اولًا في اعلي قائمة وسطاء المنطقة العقاريين.",
    // },
    // {
    //   target: ".otherEstateBroker",
    //   content:
    //     "باقي الوسطاء العقاريين: هنا يتم عرض باقي الوسطاء العقاريين في المنطقة وبالضغط علي الوسيط يمكنك الحصول علي معلومات اكثر عنه.",
    // },
  ]);

  useEffect(() => {
    let estateBrokerOpenedFirstTime = window.localStorage.getItem(
      "estateBrokerOpenedFirstTime"
    );

    if (estateBrokerOpenedFirstTime) {
      setRun(false);
    } else {
      setRun(true);
    }
  }, []);

  return (
    <>
      {isLoading ? <Spinner color={"primary"} size={"large"} /> : null}
      {!isLoading && run && !id && topBroker && (
        <Joyride
          steps={steps}
          run={run}
          continuous={run}
          disableCloseOnEsc={true}
          disableOverlayClose={true}
          showSkipButton={false}
          hideBackButton={true}
          hideCloseButton={true}
          disableScrolling={false}
          showProgress={true}
          locale={{
            back: "الرجوع",
            close: "اغلاق",
            last: "إنهاء",
            next: "التالي",
            skip: "تخطي",
          }}
          callback={(data) => {
            console.log(data);

            if (data.status == "finished" || data.action == "reset") {
              window.localStorage.setItem(
                "estateBrokerOpenedFirstTime",
                "true"
              );
              setRun(false);
            }
          }}
          styles={{
            options: {
              zIndex: 10000,
            },
          }}
        />
      )}

      {topBroker || estateBroker ? (
        <>
          {currentEstateBroker === "realEstateEmpoloyee" && (
            <IonContent>
              <div className="w-full relative flex flex-col justify-start items-center h-auto">
                <div
                  className={`w-full grid grid-cols-3 bg-primaryColor100 rounded-lg ${isPlatform("ios") && "pt-7"
                    }`}
                >
                  <div
                    className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                      } px-6 flex flex-row justify-right items-right EstateBrokerToClipboard`}
                  >
                    {(topBroker?.userId || topBroker?.id) && (
                      <button
                        onClick={() => {
                          setIsLoading(true);
                          Clipboard.write({
                            string: `https://thki.sa/app/estateBrokers/${topBroker?.userId ?? topBroker?.id
                              }`,
                          });
                          setIsLoading(false);
                          presentToastFunction(
                            presentToast,
                            "top",
                            "success",
                            `تم نسخ رابط الوسيط بنجاح`
                          );
                        }}
                        className="flex flex-col justify-center items-center"
                      >
                        <IonIcon
                          icon={shareOutline}
                          className="text-2xl text-white font-bold"
                        />
                      </button>
                    )}
                  </div>
                  <div
                    className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                      } flex flex-row justify-center items-center`}
                  >
                    <p className="font-bold text-white text-2xl whitespace-nowrap">
                      الوسيط العقاري الأكثر رواجًا
                    </p>
                  </div>
                  <div
                    className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                      } px-6 flex flex-row justify-end items-center`}
                  >
                    <button
                      onClick={() => {
                        // if (estateBroker?.userId || estateBroker?.id) {
                        // window.location.assign(`/app/home`);
                        // } else {
                        onCloseEstateBrokersDismiss(null, "cancel");
                        // }
                      }}
                      className="flex flex-col justify-center items-center"
                    >
                      <IonIcon
                        icon={chevronBackOutline}
                        className="text-2xl text-white"
                      />
                    </button>
                  </div>
                </div>
                <div className="w-full max-w-md mx-auto form-container">
                  <div className="relative mt-6 flex justify-center animate__animated animate__lightSpeedInRight photo profilePhoto">
                    <div className="relative">
                      <LightGalleryComponent
                        items={[{
                          file: !topBroker?.profileImageName || topBroker?.profileImageName === ""
                            ? userSvg
                            : topBroker?.profileImageName,
                          isImage: true,
                          name: topBroker?.nickName ?? topBroker?.fullName
                        }]}
                        itemClassName=""
                        imageClassName="rounded-full shadow-lg border-4 border-white h-40 w-40 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                      />
                      {(topBroker?.ads || topBroker?.ads === 0) && (
                        <div className="absolute -bottom-2 -right-2 bg-[#6030ff] text-white text-sm font-bold px-3 py-1 rounded-full shadow-md">
                          {topBroker?.ads} إعلان
                        </div>
                      )}
                    </div>
                  </div>

                  {(topBroker?.nickName || topBroker?.fullName) && (
                    <div className="text-center mt-4 animate__animated animate__lightSpeedInRight adsNum">
                      <h2 className="text-2xl font-bold text-primaryColor100 mb-2">
                        {topBroker?.nickName ?? topBroker?.fullName}
                      </h2>
                      {topBroker?.bio && (
                        <p className="text-lg text-gray-600 px-4 leading-relaxed">
                          {topBroker?.bio}
                        </p>
                      )}
                    </div>
                  )}

                  <hr className="h-px mx-auto bg-gray-500 my-4 border-0 rounded animate__animated animate__lightSpeedInRight" />

                  {topBroker?.address && (
                    <div className="flex justify-center items-center">
                      <span className="text-primaryColor100 whitespace-pre-wrap text-center text-lg leading-relaxed max-w-md">
                        {topBroker?.address}
                      </span>
                    </div>
                  )}

                  <hr className="h-px mx-auto bg-gray-500 my-1 opacity-20 border-0 rounded animate__animated animate__lightSpeedInRight" />

                  <div className="flex justify-center items-center gap-6 py-4 animate__animated animate__lightSpeedInLeft moreDetails">
                    <div className="flex gap-2">
                      {topBroker?.officePhoneNumber && (
                        <>
                          <a
                            href={`tel:+966${topBroker?.officePhoneNumber}`}
                            className="p-3 rounded-full bg-blue-100 hover:bg-blue-200 transition-colors"
                          >
                            <IonIcon icon={call} className="text-3xl text-blue-600" />
                          </a>
                          <a
                            href={`https://wa.me/+966${topBroker?.officePhoneNumber?.startsWith("0")
                                ? topBroker?.officePhoneNumber?.slice(1)
                                : topBroker?.officePhoneNumber
                              }`}
                            target="_blank"
                            className="p-3 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
                          >
                            <IonIcon icon={logoWhatsapp} className="text-3xl text-green-600" />
                          </a>
                        </>
                      )}

                      {topBroker?.phoneNumber && topBroker?.phoneNumber !== topBroker?.officePhoneNumber && (
                        <>
                          <a
                            href={`tel:+966${topBroker?.phoneNumber}`}
                            className="p-3 rounded-full bg-blue-100 hover:bg-blue-200 transition-colors"
                          >
                            <IonIcon icon={call} className="text-3xl text-blue-600" />
                          </a>
                          <a
                            href={`https://wa.me/+966${topBroker?.phoneNumber?.startsWith("0")
                                ? topBroker?.phoneNumber?.slice(1)
                                : topBroker?.phoneNumber
                              }`}
                            target="_blank"
                            className="p-3 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
                          >
                            <IonIcon icon={logoWhatsapp} className="text-3xl text-green-600" />
                          </a>
                        </>
                      )}

                      {topBroker?.email && (
                        <a
                          href={`mailto:${topBroker?.email}`}
                          className="p-3 rounded-full bg-red-100 hover:bg-red-200 transition-colors"
                        >
                          <IonIcon icon={mailOutline} className="text-3xl text-red-600" />
                        </a>
                      )}
                    </div>
                  </div>

                  <div className="w-full mt-6 px-4">
                    <div className="flex gap-3 animate__animated animate__fadeInUp">
                      <IonButton
                        expand="block"
                        size="large"
                        color={"primary"}
                        onClick={() => {
                          openMyAdvertisementsModal();
                          onCloseEstateBrokersDismiss(null, "cancel");
                        }}
                        className="shadow-lg flex-1 getEstateAllAds"
                        style={{
                          "--border-radius": "12px",
                          "--box-shadow": "0 4px 12px rgba(0, 0, 0, 0.15)",
                        }}
                      >
                        إعلانات الوسيط
                      </IonButton>

                      <IonButton
                        expand="block"
                        size="large"
                        fill="outline"
                        color={"primary"}
                        onClick={() => {
                          openCreateFavoriteLandModal();
                          onCloseEstateBrokersDismiss(null, "cancel");
                        }}
                        className="shadow-lg flex-1 getEstateFavourites"
                        style={{
                          "--border-radius": "12px",
                          "--box-shadow": "0 4px 12px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <IonIcon slot="start" icon={heart} color="danger" />
                        طلبات الوسيط
                      </IonButton>
                    </div>
                  </div>
                </div>
              </div>
            </IonContent>
          )}

          {currentEstateBroker === "realEstateEmpoloyeeById" && (
            <IonContent>
              <div className="w-full relative flex flex-col justify-start items-center h-auto">
                <div
                  className={`w-full grid grid-cols-3 bg-primaryColor100 rounded-lg ${isPlatform("ios") && "pt-7"
                    }`}
                >
                  <div
                    className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                      } px-6 flex flex-row justify-right items-right intializer`}
                  >
                    {(estateBroker?.userId || estateBroker?.id) && (
                      <button
                        onClick={() => {
                          setIsLoading(true);
                          Clipboard.write({
                            string: `https://thki.sa/app/estateBrokers/${estateBroker?.userId ?? estateBroker?.id
                              }`,
                          });
                          setIsLoading(false);
                          presentToastFunction(
                            presentToast,
                            "top",
                            "success",
                            `تم نسخ رابط الوسيط بنجاح`
                          );
                        }}
                        className="flex flex-col justify-center items-center"
                      >
                        <IonIcon
                          icon={shareOutline}
                          className="text-2xl text-white font-bold"
                        />
                      </button>
                    )}
                  </div>
                  <div
                    className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                      } flex flex-row justify-center items-center`}
                  >
                    <p className="font-bold text-white text-2xl whitespace-nowrap">
                      بيانات الوسيط العقاري
                    </p>
                  </div>
                  <div
                    className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                      } px-6 flex flex-row justify-end items-center`}
                  >
                    <button
                      onClick={() => {
                        if (estateBroker?.userId || estateBroker?.id) {
                          window.location.assign(`/app/home`);
                        } else {
                          onCloseEstateBrokersDismiss(null, "cancel");
                        }
                      }}
                      className="flex flex-col justify-center items-center"
                    >
                      <IonIcon
                        icon={chevronBackOutline}
                        className="text-2xl text-white"
                      />
                    </button>
                  </div>
                </div>
                <div className="w-full max-w-md mx-auto form-container estateBrokerDetails">
                  <div className="relative mt-6 flex justify-center animate__animated animate__lightSpeedInRight photo">
                    <div className="relative">
                      <LightGalleryComponent
                        items={[{
                          file: !estateBroker?.profileImage || estateBroker?.profileImage === ""
                            ? userSvg
                            : estateBroker?.profileImage,
                          isImage: true,
                          name: estateBroker?.nickName ?? estateBroker?.fullName
                        }]}
                        itemClassName=""
                        imageClassName="rounded-full shadow-lg border-4 border-white h-40 w-40 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                      />
                      {estateBroker?.ads && (
                        <div className="absolute -bottom-2 -right-2 bg-[#6030ff] text-white text-sm font-bold px-3 py-1 rounded-full shadow-md">
                          {estateBroker?.ads} إعلان
                        </div>
                      )}
                    </div>
                  </div>

                  {(estateBroker?.nickName || estateBroker?.fullName) && (
                    <div className="text-center mt-4 animate__animated animate__lightSpeedInRight">
                      <h2 className="text-2xl font-bold text-primaryColor100 mb-2">
                        {estateBroker?.nickName ?? estateBroker?.fullName}
                      </h2>
                      {estateBroker?.bio && (
                        <p className="text-lg text-gray-600 px-4 leading-relaxed">
                          {estateBroker?.bio}
                        </p>
                      )}
                    </div>
                  )}

                  <hr className="h-px mx-auto bg-gray-500 my-4 border-0 rounded animate__animated animate__lightSpeedInRight" />

                  {estateBroker?.address && (
                    <div className="flex justify-center items-center">
                      <span className="text-primaryColor100 whitespace-pre-wrap text-center text-lg leading-relaxed max-w-md">
                        {estateBroker?.address}
                      </span>
                    </div>
                  )}

                  <hr className="h-px mx-auto bg-gray-500 my-1 opacity-20 border-0 rounded animate__animated animate__lightSpeedInRight" />

                  <div className="flex justify-center items-center gap-6 py-4 animate__animated animate__lightSpeedInLeft">
                    <div className="flex gap-2">
                      {estateBroker?.officePhoneNumber && (
                        <>
                          <a
                            href={`tel:+966${estateBroker?.officePhoneNumber}`}
                            className="p-3 rounded-full bg-blue-100 hover:bg-blue-200 transition-colors"
                          >
                            <IonIcon icon={call} className="text-3xl text-blue-600" />
                          </a>
                          <a
                            href={`https://wa.me/+966${estateBroker?.officePhoneNumber?.startsWith("0")
                                ? estateBroker?.officePhoneNumber?.slice(1)
                                : estateBroker?.officePhoneNumber
                              }`}
                            target="_blank"
                            className="p-3 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
                          >
                            <IonIcon icon={logoWhatsapp} className="text-3xl text-green-600" />
                          </a>
                        </>
                      )}

                      {estateBroker?.phoneNumber && estateBroker?.phoneNumber !== estateBroker?.officePhoneNumber && (
                        <>
                          <a
                            href={`tel:+966${estateBroker?.phoneNumber}`}
                            className="p-3 rounded-full bg-blue-100 hover:bg-blue-200 transition-colors"
                          >
                            <IonIcon icon={call} className="text-3xl text-blue-600" />
                          </a>
                          <a
                            href={`https://wa.me/+966${estateBroker?.phoneNumber?.startsWith("0")
                                ? estateBroker?.phoneNumber?.slice(1)
                                : estateBroker?.phoneNumber
                              }`}
                            target="_blank"
                            className="p-3 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
                          >
                            <IonIcon icon={logoWhatsapp} className="text-3xl text-green-600" />
                          </a>
                        </>
                      )}

                      {estateBroker?.email && (
                        <a
                          href={`mailto:${estateBroker?.email}`}
                          className="p-3 rounded-full bg-red-100 hover:bg-red-200 transition-colors"
                        >
                          <IonIcon icon={mailOutline} className="text-3xl text-red-600" />
                        </a>
                      )}
                    </div>

                  </div>

                  <div className="w-full mt-6 px-4">
                    <div className="flex gap-3 animate__animated animate__fadeInUp finalizer">
                      <IonButton
                        expand="block"
                        size="large"
                        color={"primary"}
                        onClick={() => {
                          openMyAdvertisementsModal();
                          onCloseEstateBrokersDismiss(null, "cancel");
                        }}
                        className="shadow-lg flex-1"
                        style={{
                          "--border-radius": "12px",
                          "--box-shadow": "0 4px 12px rgba(0, 0, 0, 0.15)",
                        }}
                      >
                        إعلانات الوسيط
                      </IonButton>

                      <IonButton
                        expand="block"
                        size="large"
                        fill="outline"
                        color={"primary"}
                        onClick={() => {
                          openCreateFavoriteLandModal();
                          onCloseEstateBrokersDismiss(null, "cancel");
                        }}
                        className="shadow-lg flex-1"
                        style={{
                          "--border-radius": "12px",
                          "--box-shadow": "0 4px 12px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <IonIcon slot="start" icon={heart} color="danger" />
                        طلبات الوسيط
                      </IonButton>
                    </div>
                  </div>
                </div>
              </div>
            </IonContent>
          )}

          {currentEstateBroker === "realEstateEmpoloyees" && (
            <IonContent>
              <div className="w-full relative flex flex-col justify-start items-center h-auto">
                <div
                  className={`w-full grid grid-cols-3 bg-primaryColor100 rounded-lg ${isPlatform("ios") && "pt-7"
                    }`}
                >
                  <div className="col-span-1"></div>
                  <div
                    className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                      } flex flex-row justify-center items-center`}
                  >
                    <p className="font-bold text-white text-2xl whitespace-nowrap">
                      جميع الوسطاء العقاريين بالمنطقة
                    </p>
                  </div>
                  <div
                    className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                      } px-6 flex flex-row justify-end items-center`}
                  >
                    <button
                      onClick={() => {
                        // if (estateBroker?.userId || estateBroker?.id) {
                        // window.location.assign(`/app/home`);
                        // } else {
                        onCloseEstateBrokersDismiss(null, "cancel");
                        // }
                      }}
                      className="flex flex-col justify-center items-center"
                    >
                      <IonIcon
                        icon={chevronBackOutline}
                        className="text-2xl text-white"
                      />
                    </button>
                  </div>
                </div>
                <div className="form-container">
                  <IonList className="px-4 animate__animated animate__lightSpeedInRight topEstateBroker">
                    <IonItem
                      className="topEstateBroker"
                      onClick={() => {
                        setCurrentEstateBroker("realEstateEmpoloyeeById");
                        getEstateBrokerById(
                          otherBrokers?.userId ?? otherBrokers?.id
                        );
                      }}
                    >
                      <div slot="start" className="w-24 h-24">
                        <LightGalleryComponent
                          items={[{
                            file: !otherBrokers?.profileImageName || otherBrokers?.profileImageName === ""
                              ? userSvg
                              : otherBrokers?.profileImageName,
                            isImage: true,
                            name: otherBrokers?.nickName ?? otherBrokers?.fullName
                          }]}
                          itemClassName=""
                          imageClassName="rounded-full object-cover w-full h-full cursor-pointer hover:opacity-90 transition-opacity"
                        />
                      </div>
                      <IonLabel>
                        <h2 className="whitespace-pre-wrap text-xl">
                          الإسم:{" "}
                          <span className="text-primaryColor100 text-xl">
                            {otherBrokers?.nickName ??
                              otherBrokers?.fullName ??
                              "الوسيط العقاري الأكثر رواجًا"}
                          </span>
                        </h2>
                        <p className="text-xl">
                          عدد الإعلانات:{" "}
                          <span className="text-primaryColor100 text-xl font-medium">
                            {otherBrokers?.ads}
                          </span>{" "}
                          <span className="bg-primaryColor100 text-white rounded-md px-2 text-xl mr-4">
                            الوسيط الأكثر رواجًا
                          </span>
                        </p>
                      </IonLabel>
                    </IonItem>
                    {otherBrokers?.otherUsersInSameRegion?.length > 0
                      ? otherBrokers?.otherUsersInSameRegion
                        .sort((a: any, b: any) => b.ads - a.ads)
                        .map((item: any, index: any) => {
                          return (
                            <IonItem
                              className="otherEstateBroker"
                              key={index}
                              onClick={() => {
                                setCurrentEstateBroker(
                                  "realEstateEmpoloyeeById"
                                );
                                getEstateBrokerById(item?.userId ?? item?.id);
                              }}
                            >
                              <div slot="start" className="w-24 h-24">
                                <LightGalleryComponent
                                  items={[{
                                    file: !item?.profileImageName || item?.profileImageName === ""
                                      ? userSvg
                                      : item?.profileImageName,
                                    isImage: true,
                                    name: item?.nickName ?? item?.fullName
                                  }]}
                                  itemClassName=""
                                  imageClassName="rounded-full object-cover w-full h-full cursor-pointer hover:opacity-90 transition-opacity"
                                />
                              </div>
                              <IonLabel>
                                <h2 className="whitespace-pre-wrap text-xl">
                                  الإسم:{" "}
                                  <span className="text-primaryColor100 text-xl">
                                    {item?.nickName ??
                                      item?.fullName ??
                                      "الوسيط العقاري"}
                                  </span>
                                </h2>
                                <p className="text-xl">
                                  عدد الإعلانات:{" "}
                                  <span className="text-primaryColor100 text-xl font-medium">
                                    {item?.ads}
                                  </span>
                                </p>
                              </IonLabel>
                            </IonItem>
                          );
                        })
                      : null}
                  </IonList>
                </div>
              </div>
            </IonContent>
          )}

          <IonFooter
            translucent={true}
            className={`${isPlatform("ios") && "pb-4"}`}
          >
            <IonSegment value={currentEstateBroker}>
              <IonSegmentButton
                disabled={
                  currentEstateBroker == "realEstateEmpoloyee" ||
                    currentEstateBroker == "realEstateEmpoloyees"
                    ? true
                    : false
                }
                value="realEstateEmpoloyeeById"
                className="animate__animated animate__rubberBand"
              >
                <IonLabel
                  className="text-primaryColor100"
                  style={{ textWrap: "wrap" }}
                >
                  بيانات الوسيط العقاري
                </IonLabel>
                <IonIcon
                  icon={personOutline}
                  className="text-primaryColor100"
                ></IonIcon>
              </IonSegmentButton>

              <IonSegmentButton
                className="animate__animated animate__rubberBand"
                disabled={id ? true : false}
                value="realEstateEmpoloyee"
                onClick={() => {
                  setCurrentEstateBroker("realEstateEmpoloyee");
                  getTopBroker(currentRegion);
                }}
              >
                <IonLabel
                  className="text-primaryColor100"
                  style={{ textWrap: "wrap" }}
                >
                  الوسيط العقاري الأكثر رواجًا
                </IonLabel>
                <IonIcon icon={realEstateEmpoloyeeSvg}></IonIcon>
              </IonSegmentButton>

              <IonSegmentButton
                className="animate__animated animate__rubberBand"
                disabled={id ? true : false}
                value="realEstateEmpoloyees"
                onClick={() => {
                  getOtherBrokers(currentRegion);
                  setCurrentEstateBroker("realEstateEmpoloyees");
                }}
              >
                <IonLabel
                  className="text-primaryColor100"
                  style={{ textWrap: "wrap" }}
                >
                  جميع الوسطاء العقاريين
                </IonLabel>
                <IonIcon icon={realEstateEmpoloyeesSvg}></IonIcon>
              </IonSegmentButton>
            </IonSegment>
          </IonFooter>
        </>
      ) : (
        <IonContent>
          <div className="w-full relative flex flex-col justify-start items-center h-auto">
            <div
              className={`w-full grid grid-cols-3 bg-primaryColor100 rounded-lg ${isPlatform("ios") && "pt-7"
                }`}
            >
              <div className="col-span-1"></div>
              <div
                className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                  } flex flex-row justify-center items-center`}
              >
                <p className="font-bold text-white text-2xl whitespace-nowrap">
                  الوسطاء العقاريين
                </p>
              </div>
              <div
                className={`col-span-1 ${isPlatform("ios") ? "py-6" : "py-4"
                  } px-6 flex flex-row justify-end items-center`}
              >
                <button
                  onClick={() => {
                    // if (estateBroker?.userId || estateBroker?.id) {
                    // window.location.assign(`/app/home`);
                    // } else {
                    onCloseEstateBrokersDismiss(null, "cancel");
                    // }
                  }}
                  className="flex flex-col justify-center items-center"
                >
                  <IonIcon
                    icon={chevronBackOutline}
                    className="text-2xl text-white"
                  />
                </button>
              </div>
            </div>
            <div className="form-container mt-4 text-center animate__animated animate__bounceInUp">
              <div className="pt-5">
                <p className="text-3xl font-bold text-redColor mt-2">
                  لا يوجد وسطاء عقاريين بهذه المنطقة
                </p>
              </div>
              <div className="pt-5 px-32">
                <img
                  src={emptySvg}
                  className="animate__animated animate__jello animate__infinite"
                  height={150}
                  width={150}
                />
              </div>
            </div>
          </div>
        </IonContent>
      )}
    </>
  );
};

export default EstateBrokersModal;
